import { useState, useEffect } from 'react';
import { Card, CardBody, CardFooter, CardHeader, Form, FormGroup, Input, Label, Media, Row } from 'reactstrap';
import { Btn, H3, Image } from 'AbstractElements';
import user from 'assets/images/user/7.jpg';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Moment from 'moment';
import 'moment/locale/id';
import { handleLoginAs, handleUnlock } from '../UsersUtils';

const UserProfile = () => {
  const userDetail = useSelector(state => state.User.detail);
  const filters = useSelector(state => state.User.filters);
  const [detail, setDetail] = useState({});
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    setDetail(userDetail);
  }, [userDetail]);

  const validImageExtensions = [".jpg", ".jpeg", ".png"];
  const isValidImage = (url) => {
    const extension = url.substring(url.lastIndexOf(".")).toLowerCase();
    return validImageExtensions.includes(extension);
  }

  return (
    <Card>
      <CardHeader className="pb-0">
        {/* <H4 attrH4={{ className: 'card-title mb-0' }}>{MyProfile}</H4> */}
        <div className="card-options">
          <a className="card-options-collapse" href="#javascript">
            <i className="fe fe-chevron-up"></i>
          </a>
          <a className="card-options-remove" href="#javascript">
            <i className="fe fe-x"></i>
          </a>
        </div>
      </CardHeader>
      <CardBody>
        <Form>
          <Row className="mb-2">
            <div className="profile-title">
              <Media>
                <Image attrImage={{ className: 'img-70 rounded-circle', alt: '', src: detail.photo_profile ? !isValidImage(detail.photo_profile) ? user : detail.photo_profile : user }} />
                <Media body>
                  <H3 attrH3={{ className: 'mb-1 f-20 txt-primary' }}>
                    {detail.name || 'User Name'}
                  </H3>
                </Media>
              </Media>
              {detail.is_qc == 13 && (
                <span className="badge bg-success">Akun QC</span>
              )}
            </div>
          </Row>
          <FormGroup className="mb-3">
            <Label className="form-label"><b>Jenis Kelamin</b></Label>
            <Input readOnly className="form-control" value={detail.gender == 'Male' ? 'Pria' : detail.gender == 'Female' ? 'Wanita' : '-'} />
          </FormGroup>
          <FormGroup className="mb-3">
            <Label className="form-label"><b>Tanggal Lahir</b></Label>
            <Input readOnly className="form-control" defaultValue={detail.birthday} />
          </FormGroup>
          <FormGroup className="mb-3">
            <Label className="form-label"><b>No. HP</b></Label>
            <Input readOnly className="form-control" defaultValue={detail.phone} />
          </FormGroup>
          {detail.parent_user && (
            <>
              <FormGroup className="mb-3">
                <Label className="form-label"><b>Nama Wali</b></Label>
                <Input readOnly className="form-control" defaultValue={detail.parent_user ? detail.parent_user.name : '-'} />
              </FormGroup>
              <FormGroup className="mb-3">
                <Label className="form-label"><b>No. HP Wali</b></Label>
                <Input readOnly className="form-control" defaultValue={detail.parent_user ? detail.parent_user.phone : '-'} />
              </FormGroup>
            </>
          )}
          <FormGroup className="mb-3">
            <Label className="form-label"><b>Source</b></Label>
            <Input readOnly className="form-control" defaultValue={detail.source} />
          </FormGroup>
          <FormGroup className="mb-3">
            <Label className="form-label"><b>Whatsapp {detail.verified_at ? 'Verified' : 'Unverified'}</b></Label>
            <Input readOnly className="form-control" defaultValue={detail.verified_at} />
          </FormGroup>
          <FormGroup className="mb-3">
            <Label className="form-label"><b>Email Verified</b></Label>
            <Input readOnly className="form-control" defaultValue={detail.email_verified_at ? Moment(detail.email_verified_at).format('dddd, D MMMM YYYY - HH:mm:ss') + ' WIB' : ""} />
          </FormGroup>
          <FormGroup className="mb-3">
            <Label className="form-label"><b>Percobaan Login Gagal</b></Label>
            <Input readOnly className="form-control" value={detail.failed_login_attempts ?? 0} />
          </FormGroup>
          {detail.locked_at && (
            <FormGroup className="mb-3">
              <Label className="form-label"><b>Akun Terkunci Sejak</b></Label>
              <Input
                readOnly
                className="form-control"
                value={Moment(detail.locked_at).format('dddd, D MMMM YYYY - HH:mm:ss') + ' WIB'}
              />
            </FormGroup>
          )}
          {detail.last_seen && (
            <FormGroup className="mb-3">
              <Label className="form-label"><b>Terakhir Online</b></Label>
              <Input
                readOnly
                className="form-control"
                value={Moment(detail.last_seen).format('dddd, D MMMM YYYY - HH:mm:ss') + ' WIB'}
              />
            </FormGroup>
          )}
          <FormGroup className="mb-3">
            <Label className="form-label"><b>Penghapusan Mandiri</b></Label>
            <Input
              readOnly
              className="form-control"
              value={detail.is_self_delete ? 'Ya' : 'Tidak'}
            />
          </FormGroup>
          <FormGroup className="mb-0">
            <Label><b>Created at :</b></Label>
            <Label>{Moment(detail.created_at).format('dddd, D MMMM YYYY')} - {Moment(detail.created_at).format('HH:mm:ss')} WIB</Label>
          </FormGroup>
          <FormGroup className="mb-0">
            <Label><b>Updated at :</b></Label>
            <Label>{Moment(detail.updated_at).format('dddd, D MMMM YYYY')} - {Moment(detail.updated_at).format('HH:mm:ss')} WIB</Label>
          </FormGroup>
        </Form>
      </CardBody>
      <CardFooter>
        <div className="d-flex flex-column gap-2 justify-content-between">
          <Btn
            attrBtn={{
              title: 'Login As',
              color: 'link',
              outline: true,
              className: 'btn btn-primary m-r-10 w-100',
              onClick: () => handleLoginAs(detail.id, detail.name)
            }}
          >
            Login As <i className="fa fa-sign-in mx-auto fa-lg"></i>
          </Btn>
          {
            detail?.fcm_tokens && detail?.fcm_tokens.length > 0 && (
              <Btn
                attrBtn={{
                  title: 'Kirim Notifikasi',
                  color: 'link',
                  outline: true,
                  className: 'btn btn-success m-r-10 w-100',
                  onClick: () => {
                    navigate(`${process.env.PUBLIC_URL}/users/push-notif`, { state: { userFcm: detail?.fcm_tokens?.[0]?.fcm_token } })
                    window.scrollTo(0, 0);
                  }
                }}
              >
                Kirim Notifikasi <i className="fa fa-paper-plane mx-auto"></i>
              </Btn>
            )
          }
          {
            detail?.locked_at !== null &&
            <Btn
              attrBtn={{
                title: 'Unlock Akun',
                color: 'link',
                outline: true,
                className: 'btn btn-info m-r-10 w-100',
                onClick: () => handleUnlock(detail.id, detail.name, filters, dispatch, true)
              }}
            >
              Unlock Akun <i className="fa fa-unlock mx-auto"></i>
            </Btn>
          }
          <Link to={`${process.env.PUBLIC_URL}/users/user-list`}>
            <Btn attrBtn={{ color: 'warning', className: 'btn btn-primary m-r-10 w-100' }}>
              <i className="fa fa-chevron-circle-left fa-lg me-2"></i>Back
            </Btn>
          </Link>
        </div>
      </CardFooter>
    </Card>
  );
};
export default UserProfile;